import { DataAccess } from "../../dataaccess/data.access";
import { Integration } from "../integrations/integration.service";
import { TelemetryService } from "../../services/telemetry.service";
import { EvCustAtrb } from "../../services/master.definitions/custom.attributes/custom.attribute.event.service";

export interface PoolLiteTO {
    id?: number;
    parent_id?: number;
    name?: string;
    type?: "application" | "profile";
}

export class AdmitService {
    public static async createIntegration(): Promise<Integration> {
        TelemetryService.sendWithSub("SysSettings", "Integrations", "AdmitOn");
        return DataAccess.post("/admit/inst.json");
    }

    // note: adds a numeric event custom attr on the event with the Admit pool id as a value
    public static async createPool(eventId: number, poolName: string, parentPoolId: number): Promise<EvCustAtrb> {
        TelemetryService.send("Admit", "CreatePool");
        let url = `/admit/pool.json?eventId=${eventId}&poolName=${encodeURIComponent(poolName)}`;
        if (parentPoolId) {
            url += `&parentPoolId=${parentPoolId}`;
        }
        return DataAccess.post(url);
    }

    public static async getPools(): Promise<PoolLiteTO[]> {
        return DataAccess.get("/admit/pools.json");
    }

    public static getRedirectUrl() {
        return AdmitService.formUrl("/redirect/app?app=admit");
    }

    public static getAdmitEventsLink(poolId: number) {
        return AdmitService.formUrl(`/redirect/app?app=admit&redirect=/prospect/pools/${poolId}/events`);
    }

    private static formUrl(path: string) {
        let url = DataAccess.getUrl(path);
        if (window.location.hostname === "localhost") {
            url += "&fullToken=true";
        }
        return url;
    }
}
